import type { SignupData } from './types';

// Must match the mode (test/live) of the backend's stripe.secret-key, and the
// price must exist in that same mode. Falls back to live for mode-less builds
// (build:signup / watch:signup load no .env.<mode> file).
export const STRIPE_PUBLISH_KEY = import.meta.env.VITE_STRIPE_PUBLISH_KEY || 'pk_live_vOk9spUL834YLjt3yQJ5sa4G00JzdPEqkv';
export const STRIPE_PRICE_ID = import.meta.env.VITE_STRIPE_PRICE_ID || 'price_1KV5FGBPte15PHQefAogXjqy';

let backendVersion: number | null = null;

function getApiStart(): string {
  const base = import.meta.env.VITE_API_BASE_URL || "https://orna-prod.kerkton.com:8443";
  return `${base}/api/v${backendVersion}/`;
}

function extractVersionNumberFromBackendJs(backendJs: string): number {
  const match = backendJs.match(/\d+/);
  return +(match?.[0] ?? '0');
}

export async function initBackendVersion(): Promise<void> {
  const response = await fetch('/Content/orna-backend-version.js');
  if (!response.ok) throw new Error('Failed to fetch backend version');
  const text = await response.text();
  backendVersion = extractVersionNumberFromBackendJs(text);
}

export async function validateUsername(username: string): Promise<{ validationError?: string }> {
  const params = new URLSearchParams({ username });
  const response = await fetch(`${getApiStart()}username/validate/?${params.toString()}`);
  if (!response.ok) throw new Error('Username validation request failed');
  return response.json();
}

export async function getSetupIntentClientSecret(attachToCurrentCompany: boolean): Promise<{ clientSecret?: string }> {
  const flag = attachToCurrentCompany ? 'true' : 'false';
  const response = await fetch(`${getApiStart()}admin/payment/card/setupintentclientsecret?attachToCurrentCompany=${flag}`);
  if (!response.ok) throw new Error('Failed to get setup intent');
  return response.json();
}

export async function signup(data: SignupData): Promise<unknown> {
  const response = await fetch(`${getApiStart()}signup`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const body = await response.json();
    const err = new Error('Signup failed') as Error & { responseJSON: unknown };
    err.responseJSON = body;
    throw err;
  }
  return response.json();
}
